// extracted by mini-css-extract-plugin
export default {"inputRoot":"ButtonStoreOnLocalDrive_inputRoot__wsJ+1","inputWrapper":"ButtonStoreOnLocalDrive_inputWrapper__cO2v7","icon":"ButtonStoreOnLocalDrive_icon__w0BPm"};